import { Box, Typography, TextField, ButtonGroup, Divider, Button } from '@mui/material';
import { useState, useEffect, useCallback } from 'react';
import useResponsive from '../../hooks/useResponsive';
import useDebounce from '../../hooks/useDebounce';
import Iconify from '../Iconify';
import '../../css/sites/sitesFiltration.css';

const SiteFiltration = ({ filtersEmpty, siteFilters, setSiteFilters, totalSites, filteredSitesCount, sitesFetched, selectedDisplayMode, setSelectedDisplayMode }) => {

    const isDesktop = useResponsive('up', 'lg');

    const [search, setSearch] = useState(siteFilters.debouncedSearch || '');
    const debouncedSearch = useDebounce(search, 1000);

    // Update filters when debounced search changes
    useEffect(() => {
        setSiteFilters((prev) => ({ ...prev, debouncedSearch: debouncedSearch }));
    }, [debouncedSearch, setSiteFilters]);

    const handleGridMode = useCallback(() => {
        setSelectedDisplayMode('grid');
    }, [setSelectedDisplayMode]);

    const handleListMode = useCallback(() => {
        setSelectedDisplayMode('list');
    }, [setSelectedDisplayMode]);

    return (
        <Box className='sites_Filtration_counts'>
            <Box className='sites_Filtration_wrapper'>
                <Box className='sites_Filtration_container'>

                    <TextField
                        size="small"
                        value={search}
                        placeholder='Rechercher'
                        onChange={(e) => setSearch(e.target.value)}
                        variant="outlined"
                        className='sites_Filtration_search_Box'
                        InputProps={{
                            startAdornment: <Iconify icon={"bx:bx-search"} className='sites_Filtration_search_icon' />,
                            sx: {
                                backgroundColor: '#fff',
                                height: '36px',
                                fontFamily: 'Mulish',
                                color: '#201E1E',
                                fontSize: '14px',
                                fontWeight: 400,
                            },
                        }}
                    />

                    {isDesktop && <Divider orientation="vertical" variant="middle" flexItem />}

                    <ButtonGroup variant="outlined">
                        <Button
                            className={selectedDisplayMode === 'grid' ? 'sites_Filtration_options_selected_button' : 'sites_Filtration_options_button'}
                            onClick={handleGridMode}
                        >
                            <Iconify icon={"gg:menu-grid-r"} />
                        </Button>
                        <Button
                            className={selectedDisplayMode === 'list' ? 'sites_Filtration_options_selected_button' : 'sites_Filtration_options_button'}
                            onClick={handleListMode}
                        >
                            <Iconify icon={"ph:list"} />
                        </Button>
                    </ButtonGroup>
                </Box>

            </Box>

            <Typography className='sites_Filtration_total_number'>
                {sitesFetched} affichés
                {!filtersEmpty && ` / ${filteredSitesCount} filtrés`}
                {` / ${totalSites} au total`}
            </Typography>

        </Box>
    );
};

export default SiteFiltration;